import { useContext } from "react";
import { MeContext } from "contexts/me-context/me-context";

/**
 * Gate de UI (UX only) — espelha `me.permissions` (RBAC, populado por GET /user/me).
 * O enforcement real é sempre no guard central do backend (`adaptRoute`); esconder um
 * botão aqui nunca substitui a checagem de permissão na rota.
 */
export const usePermission = (permission: string): boolean => {
    const { me } = useContext(MeContext);
    // Transição RBAC: enquanto o backend não devolve `permissions` (ambiente
    // ainda sem o RBAC da API), admin legado mantém acesso — senão o gate
    // fica fail-closed e tranca telas cujo backend nem impõe permissão ainda.
    // Assim que `permissions` existir (mesmo []), o RBAC governa e este
    // fallback se desativa sozinho.
    if (me?.permissions == null) return me?.role === "admin";
    return me.permissions.includes(permission);
};
